<template>
    <div v-if="!(value == null && value === '')">
        <span v-if="value === 'REASON_0'" class="">
<!--            zapnutí zařízení-->
        </span>
        <span v-else-if="value === 'REASON_1'" class="">příkaz od uživatele</span>
        <span v-else-if="value === 'REASON_2'" class="">překročení limitu průtoku</span>
        <span v-else-if="value === 'REASON_3'" class="">překročení limitu nepřetržitého odběru</span>
        <span v-else-if="value === 'REASON_4'" class="">překročení limitu úkapu</span>
        <span v-else-if="value === 'REASON_5'" class="">překročení limitu odběru za čas
</span>
        <span v-else-if="value === 'REASON_6'" class="">ručně</span>
    </div>
</template>

<script>
export default {
    name: 'Reason',
    props: ['value']
}
</script>

<style scoped>
.fa-battery-full {
    color: #05B408;
}
.fa-battery-three-quarters {
    color: #05B408;
}
.fa-battery-half {
    color: #F6AF00;
}
.fa-battery-quarter {
    color: #c9302c;
}
.fa-battery-empty {
    color: #c9302c;
}
</style>
